import { Trade as trade, Trade } from './trade';
export class TradeSet {
  public tradeSetId;
  public portfolioId;
  public canEdit: boolean;
  public portfolioName;
  public dateGenerated;
  public dateFinalised;
  public finalised;
  public cModel;
  public targetCashAllocation: number;
  //public targetPreciousMetalAllocation: number;
  //public targetAlternativesAllocation: number;
  public currencyBalances: any[];
  public trades: Array<Trade>;
  public clientName: string;
  public owner: string;

  public constructor(tradeSetDTO: any) {
    this.tradeSetId = tradeSetDTO.tradeSetId;
    this.portfolioId = tradeSetDTO.portfolioId;
    this.canEdit = tradeSetDTO.canEdit;
    this.portfolioName = tradeSetDTO.portfolioName;
    this.dateGenerated = tradeSetDTO.dateGenerated;
    this.dateFinalised = tradeSetDTO.dateFinalised;
    this.finalised = tradeSetDTO.finalised;
    this.cModel = tradeSetDTO.cModel;
    this.clientName = tradeSetDTO.clientName;
    this.owner = tradeSetDTO.owner;
    this.targetCashAllocation = tradeSetDTO.targetCashAllocation;
    //this.targetPreciousMetalAllocation = 0;
    //this.targetAlternativesAllocation = 0;
    this.currencyBalances = tradeSetDTO.currencyBalances;
    var items = tradeSetDTO.trades || [];
    this.trades = items.map(i => new Trade(i))
      .sort((a, b) => {
        if (a.security.description > b.security.description) {
          return 1;
        } else if (a.security.description < b.security.description) {
          return -1;
        } else {
          return 0;
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/trading/models/tradeSet.ts